import { useMemo, useState } from 'react';
import { isClubStaff, isCoach, isGuest, isUser } from '../../../util/UserRoles.js';
import { FormControl, FormControlLabel, FormLabel, LinearProgress, Menu, MenuItem, Radio, RadioGroup } from '@mui/material';
import { useNavigate } from 'react-router';
import checkImg from "../../../assets/images/shield.gif";
import CustomDialog from '../../CustomComponents/CustomDialog/CustomDialog.jsx';
import { CiMenuKebab } from "react-icons/ci";
import { MdOutlineContentCopy, MdOutlineModeEditOutline } from 'react-icons/md';
import { SeasonStatus } from '../../../util/SeasonStatus.js';
import { Privileges } from '../../../util/PrivilegeConstants.js';
import AddPlanDialog from '../Roster/AddPlanDialog.jsx';
import { EventAPI } from '../../../api/EventAPI.js';
import Loader from '../../../component/Loader.jsx';
import EmojiList from '../../CustomComponents/EmojiList.jsx';
import { GoDownload } from "react-icons/go";
import { FaLink } from "react-icons/fa";

import RegPlayerAvatar from './RegPlayerAvatar.jsx';


const radioBtmStyle = {
    '&.Mui-checked': {
        color: 'var(--hoverColorBold)', // checked color
    },
    '&.Mui-checked ~ .MuiFormControlLabel-label': {
        color: 'var(--hoverColorBold)',
    },
}
const IceIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v20M4.93 4.93l14.14 14.14M2 12h20M4.93 19.07L19.07 4.93" /></svg>;
const CalendarIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>;
const CheckIcon = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>;
const UserIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>;
const ChevronDown = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>;
const MenuIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="18" x2="21" y2="18" /></svg>;
const MessageIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>;
function ProgressBar({ registered, total }) {
    const pct = total === 0 ? 0 : Math.round((registered / total) * 100);
    const colorClass = pct >= 100 ? "progress-bar__fill--red" : pct >= 50 ? "progress-bar__fill--amber" : "progress-bar__fill--green";
    return (
        <div className="progress-bar">
            <div className={`progress-bar__fill ${colorClass}`} style={{ width: `${pct}%` }} />
        </div>
    );
}


const EventDataCard = ({ event, userInfo, children, handleOpenEditSeasonPopup, privileges, index }) => {
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedChild, setSelectedChild] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const [whoRegister, setWhoRegister] = useState('');
    const [openAddPlanPopup, setOpenAddPlanPopup] = useState(false);
    const [openFeePopup, setOpenFeePopup] = useState(false);
    const [participantFee, setParticipantFee] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const handleActionMenuClose = () => {
        setAnchorEl(null);
    };
    const navigate = useNavigate();
    const option = {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    }


    const handleRegister = async () => {
        if (whoRegister === '') {
            return;
        }
        const isPlayerAccess = whoRegister === 'REGISTER_YOURSELF';
        navigate("/registration", {
            state: {
                eventId: event.eventId,
                guardianId: userInfo.userId,
                isPlayer: isPlayerAccess,
                child: isPlayerAccess ?
                    {
                        childrenId: userInfo.userId,
                        firstName: userInfo.firstName,
                        lastName: userInfo.lastName,
                        dob: userInfo.dob
                    }
                    : children.find(child => child.childrenId === selectedChild) ?? {},
                playerId: userInfo.userId,
                formTemplateId: event.formTemplateId
            }
        })
    }


    const openAddPlanDialog = async () => {
        try {
            if (whoRegister === 'REGISTER_YOUR_CHILD' && !selectedChild) return;
            const response = await EventAPI.getEventPlayerParticipantFee(
                event.eventId,
                whoRegister === 'REGISTER_YOURSELF' ? userInfo.userId : selectedChild
            );
            setParticipantFee(response.Data);
            setOpenAddPlanPopup(false);
            setOpenFeePopup(true);
        } catch (error) {
            console.log(error);
        }
    };

    // let childrenListByUser = children?.filter((child) => season?.childIds?.includes(child.childrenId));
    // let newChildrenList = children?.filter((child) => !season?.childIds?.includes(child.childrenId));
    const childIdSet = useMemo(() => new Set(event?.playerIds || []), [event?.playerIds]);

    const { childrenListByUser, newChildrenList } = useMemo(() => {
        const byUser = [];
        const newList = [];

        children?.forEach((child) => {
            if (childIdSet.has(child.childrenId)) {
                byUser.push(child);
            } else {
                newList.push(child);
            }
        });

        return {
            childrenListByUser: byUser,
            newChildrenList: newList
        };
    }, [children, childIdSet]);
    const isFull = childrenListByUser?.length >= children?.length;
    return (
        <>
            {isLoading && <Loader />}
            <div className="event-card" style={{ animationDelay: `${index * 0.08}s` }}>
                <div className="event-card__header">
                    <div>
                        <div className="event-card__status-badge"><span className="event-card__status-dot" /> {event?.status === 'ACTIVE' ? 'UPCOMING' : event?.status?.replaceAll("_", " ")}</div>
                        <h3 className="event-card__title">{event.eventName}</h3>
                    </div>
                    {event?.profileImages?.length > 0 &&
                        <RegPlayerAvatar
                            maxVisible={4}
                            imgs={event?.profileImages}
                            size={20}
                        />}
                    {privileges?.MANAGE_EVENT?.includes(Privileges.MODIFY) &&
                        <CiMenuKebab onClick={(e) => setAnchorEl(e.currentTarget)} className='sm_season_card_edit_icon' />}
                </div>

                <div className="event-card__dates">
                    {event?.startDate && <div className="event-card__reg-period"><CalendarIcon />
                        <span>Registration: {new Date(event?.startDate).toLocaleDateString('en-US', option)} - {new Date(event?.endDate).toLocaleDateString('en-US', option)}
                        </span>
                    </div>}
                    {event?.eventDate && <div className="event-card__event-date-row">
                        <span className="event-card__event-date-label">Event Date</span>
                        <span className="event-card__event-date-value">{new Date(event?.eventDate).toLocaleDateString('en-US', option)}</span>
                    </div>}
                </div>

                {((isCoach(userInfo) || isUser(userInfo) || isClubStaff(userInfo) || isGuest(userInfo)) && children?.length != 0) &&
                    <div className="event-card__progress">
                        <ProgressBar registered={childrenListByUser?.length} total={children?.length} />
                        <div className="event-card__progress-meta">
                            <span className="event-card__progress-text">Registered {childrenListByUser?.length} of {children?.length} Children</span>
                            {isFull && <span className="event-card__full-badge">FULL</span>}
                        </div>
                    </div>}

                {(event?.playerIds?.includes(userInfo.userId) && (isCoach(userInfo) || isUser(userInfo) || isClubStaff(userInfo) || isGuest(userInfo))) ?
                    <div className="event-card__registered-badge"><CheckIcon /> You are already registered</div>
                    :
                    <div style={{ height: '0px' }}>

                    </div>}
                {/* {((isCoach(userInfo) || isUser(userInfo) || isClubStaff(userInfo) || isGuest(userInfo)) &&
                    event?.status === SeasonStatus.REGISTRATION_OPENED &&
                    (childrenListByUser?.length !== 0 || event?.playerIds?.includes(userInfo.userId))) ?
                    <>
                        <button className='btn--secondary-extra' type='button' onClick={() => {
                            setOpenAddPlanPopup(true)
                        }}  > <p>Add More Plan</p>
                        </button>
                    </>
                    :
                    <div style={{ height: '0px' }}>

                    </div>
                } */}
                <div className="event-card__actions">
                    {((isCoach(userInfo) || isUser(userInfo) || isClubStaff(userInfo) || isGuest(userInfo)) && event?.status === SeasonStatus.REGISTRATION_OPENED) &&
                        <button className='btn btn--primary' onClick={() => {
                            setOpenDialog(true)
                        }}  > Register
                        </button>
                    }
                    <button className="btn btn--secondary" onClick={() => {
                        navigate('/event-details', {
                            state: {
                                'event': event
                            }
                        })
                    }} >View Details</button>
                </div>

            </div>




            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleActionMenuClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={() => {
                    handleOpenEditSeasonPopup(event);
                    setAnchorEl(null);
                }
                }><MdOutlineModeEditOutline className='sm_season_edit_option_icon' />Edit</MenuItem>
            </Menu>
            <CustomDialog
                isOpen={openDialog}
                onClose={() => setOpenDialog(false)}
                onCancel={() => {
                    setOpenDialog(false)
                    setSelectedChild('')
                    setWhoRegister('')
                }}
                onSubmit={() => handleRegister()}
                title="Please select who you want to register"
                submitBtnName='next'
            >
                <div className='sm_event_who_register'>
                    <RadioGroup
                        value={whoRegister || ''}
                        onChange={(event) => setWhoRegister(event.target.value)}
                    >
                        <FormControlLabel
                            disabled={event?.playerIds?.includes(userInfo.userId)}
                            value='REGISTER_YOURSELF'
                            control={<Radio sx={radioBtmStyle} />} label='Register yourself' />
                        <FormControlLabel
                            value='REGISTER_YOUR_CHILD'
                            control={<Radio sx={radioBtmStyle} />} label='Register your child' />
                    </RadioGroup>
                </div>
                {whoRegister === 'REGISTER_YOUR_CHILD' &&
                    <div className="sm_season_add_dialog">
                        {newChildrenList.length == 0 ?
                            <p> All your children are registered </p>
                            : <FormControl>
                                <FormLabel sx={{
                                    '&.Mui-focused': {
                                        color: 'var(--hoverColorBold)', // checked color
                                    }
                                }} id="demo-radio-buttons-group-label">Your Children</FormLabel>
                                <RadioGroup
                                    value={selectedChild || ''}
                                    onChange={(event) => setSelectedChild(event.target.value)}
                                >
                                    {newChildrenList?.map((child, index) =>
                                        <FormControlLabel key={index}
                                            value={child?.childrenId}
                                            control={<Radio sx={radioBtmStyle} />}
                                            label={child?.firstName + " " + child?.lastName}
                                        />
                                    )}
                                </RadioGroup>
                            </FormControl>}
                    </div>}
            </CustomDialog>
            <CustomDialog
                isOpen={openAddPlanPopup}
                onClose={() => setOpenAddPlanPopup(false)}
                onCancel={() => {
                    setOpenAddPlanPopup(false)
                    setSelectedChild('')
                    setWhoRegister('')
                }}
                onSubmit={() => openAddPlanDialog()}
                title="Please select an option"
                submitBtnName='next'
            >
                <div className='sm_event_who_register'>
                    <RadioGroup
                        value={whoRegister || ''}
                        onChange={(event) => setWhoRegister(event.target.value)}
                    >
                        <FormControlLabel
                            disabled={!event?.playerIds?.includes(userInfo.userId)}
                            value='REGISTER_YOURSELF'
                            control={<Radio sx={radioBtmStyle} />} label='For yourself' />
                        <FormControlLabel
                            value='REGISTER_YOUR_CHILD'
                            control={<Radio sx={radioBtmStyle} />} label='For your child' />
                    </RadioGroup>
                </div>
                {whoRegister === 'REGISTER_YOUR_CHILD' &&
                    <div className="sm_season_add_dialog">
                        {childrenListByUser.length == 0 ?
                            <p> No registered Child found</p>
                            : <FormControl>
                                <FormLabel sx={{
                                    '&.Mui-focused': {
                                        color: 'var(--hoverColorBold)', // checked color
                                    }
                                }} id="demo-radio-buttons-group-label">Your Children</FormLabel>
                                <RadioGroup
                                    value={selectedChild || ''}
                                    onChange={(event) => setSelectedChild(event.target.value)}
                                >
                                    {childrenListByUser?.map((child, index) =>
                                        <FormControlLabel key={index}
                                            value={child?.childrenId}
                                            control={<Radio sx={radioBtmStyle} />}
                                            label={child?.firstName + " " + child?.lastName}
                                        />
                                    )}
                                </RadioGroup>
                            </FormControl>}
                    </div>}
            </CustomDialog>
            <AddPlanDialog
                eventId={event.eventId}
                isPlayer={whoRegister === 'REGISTER_YOURSELF'}
                playerId={whoRegister === 'REGISTER_YOURSELF' ? userInfo.userId : selectedChild}
                openFeePopup={openFeePopup}
                setOpenFeePopup={setOpenFeePopup}
                isPlanReplaceable={event?.isPlanReplaceable}
                existingFeeList={participantFee}
                setIsLoading={setIsLoading}

            />
        </>
    )
}

export default EventDataCard